import match from 'lodash.ismatch';
import { Variant } from '@ts/variant';

export default function recoverSelection(
  currentSelection: Record<string, string | number>,
  incomingSelection: Record<string, string | number>,
  variants: Variant[],
) {
  const keys = Object.keys(currentSelection).filter(
    (k) => !incomingSelection[k],
  );
  const selection = { ...currentSelection, ...incomingSelection };
  for (let i = 0; i < keys.length; i += 1) {
    const sample = variants.filter((v) => match(v, selection));
    if (sample.length > 0) return selection;
    delete selection[keys[i]];
  }
  return selection;
}
